import { HealthBar } from '@appd/uik';
import { HealthStatus, getHealthStatusDef } from '../health';

export interface HealthCounts {
  critical: number;
  warning: number;
  unknown: number;
  normal: number;
}

export interface Props {
  healthCounts: HealthCounts;
}

export const DashifyHealthBar = ({ healthCounts }: Props): JSX.Element => {
  const total = !Array.isArray(healthCounts)
    ? healthCounts.critical + healthCounts.warning + healthCounts.unknown + healthCounts.normal
    : 0;

  return !healthCounts ? (
    <div>No Data</div>
  ) : (
    <div>
      <HealthBar
        style={{ fontSize: '12px', margin: '10px 0 10px' }}
        segments={[
          {
            status: {
              color: getHealthStatusDef(HealthStatus.CRITICAL).color,
              name: 'Critical',
            },
            value: healthCounts.critical,
          },
          {
            status: {
              color: getHealthStatusDef(HealthStatus.WARNING).color,
              name: 'Warning',
            },
            value: healthCounts.warning,
          },
          {
            status: {
              color: getHealthStatusDef(HealthStatus.UNKNOWN).color,
              name: 'Unknown',
            },
            value: healthCounts.unknown,
          },
          {
            status: {
              color: getHealthStatusDef(HealthStatus.NORMAL).color,
              name: 'Normal',
            },
            value: healthCounts.normal,
          },
        ]}
        decimalPlaces={0}
        labelAlign="LEFT"
      />
    </div>
  );
};
